import { Controller } from "@hotwired/stimulus"
import showInfoModal from "../utils/info_modal"

export default class extends Controller {
  static targets = ["form"]

  submit(event) {
    event.preventDefault()
    const formData = new FormData(this.formTarget)
    const payload = {}
    formData.forEach((value, key) => {
      const match = key.match(/^checkpoint_response\[(.+)\]$/)
      if (match) {
        payload[match[1]] = value
      }
    })

    fetch(this.formTarget.action, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ checkpoint_response: payload }),
      credentials: "same-origin"
    })
      .then(r => {
        if (!r.ok) throw new Error("Request failed")
        return r.json()
      })
      .then(() => {
        this.element.classList.add("opacity-50")
        setTimeout(() => this.element.remove(), 200)
        this.dispatch("submitted", { bubbles: true })
      })
      .catch(() => showInfoModal("Unable to save feedback"))
  }
}
